import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const CauchyResidueTheorem = () => (
  <QPhototModuleSubtopic
    title="Cauchy Residue Theorem"
    videos={[
      "https://www.youtube.com/embed/Cpz7Qf2id5k",
      "https://www.youtube.com/embed/-RnsI_WXl5U",
      "https://www.youtube.com/embed/4aAPmPNZl5I",
      "https://www.youtube.com/embed/82N_QZ2vhYg"

    ]}
    takeaways={[]}
    questions={[
        {image:"/cvla_35.png"},
        {image:"/cvla_36.png"},
        {image:"/cvla_37.png"},
        {image:"/cvla_38.png"},
        {image:"/cvla_39.png"},
        {image:"/cvla_40.png"},
    ]}
    exampleVideos={[]}
  />
);

export default CauchyResidueTheorem;
